import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, ButtonBase, Typography } from "@mui/material";
import { LocalOffer as OfferIcon } from "../icons";
import { Event as EventIcon } from "../icons";
import { DirectionsCar as CarIcon } from "../icons";
import { Home as PlaceIcon } from "../icons";
import { Storefront as StoreIcon } from "../icons";
import { DeliveryDining as FoodIcon } from "../icons";
import { Payment as PlanIcon } from "../icons";
import { ChevronRight as ChevronRightIcon } from "../icons";
import { brandColors } from "../theme";

const ICONS = { oferta: OfferIcon, evento: EventIcon, auto: CarIcon, propiedad: PlaceIcon, tienda: StoreIcon, local: FoodIcon, plan: PlanIcon };

// Publicaciones que encontró la IA (functions/aiAssistant.js), como tarjetas
// que se tocan enteras: ícono del tipo, título, detalle y flecha. Las usan el
// asistente flotante y el chat de soporte. tone="light": el widget flotante
// tiene colores claros fijos, no los del tema.
const AiLinkButtons = ({ links, onNavigate, tone }) => {
  if (!links?.length) return null;
  const light = tone === "light";
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, mt: 1 }}>
      {links.map((link) => {
        const Icon = ICONS[link.type] || OfferIcon;
        return (
          <ButtonBase
            key={link.url}
            component={RouterLink}
            to={link.url}
            onClick={onNavigate}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.25,
              width: "100%",
              p: 1,
              textAlign: "left",
              borderRadius: 2,
              border: 1,
              borderColor: light ? "#e0e0e0" : "divider",
              bgcolor: light ? "#ffffff" : "background.paper",
              color: light ? "#222222" : "text.primary",
              transition: "border-color 0.15s, background-color 0.15s",
              "&:hover": { borderColor: brandColors.accent, bgcolor: light ? "#f5f9f6" : "action.hover" },
            }}
          >
            <Box
              sx={{
                flexShrink: 0,
                width: 34,
                height: 34,
                borderRadius: 1.5,
                display: "grid",
                placeItems: "center",
                bgcolor: light ? "#e8f5ec" : "action.selected",
                color: light ? "#1f8b4d" : brandColors.accent,
              }}
            >
              <Icon sx={{ fontSize: 18 }} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                sx={{
                  fontSize: "0.82rem",
                  fontWeight: 600,
                  lineHeight: 1.3,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {link.title}
              </Typography>
              {link.detail && (
                <Typography noWrap sx={{ fontSize: "0.72rem", color: light ? "#777777" : "text.secondary", mt: 0.25 }}>
                  {link.detail}
                </Typography>
              )}
            </Box>
            <ChevronRightIcon sx={{ fontSize: 18, color: light ? "#999999" : "text.secondary", flexShrink: 0 }} />
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default AiLinkButtons;
